module.exports = __webpack_public_path__ + "img/DuvidasesuportePerson.0b26450.png";